import React from 'react'
import i18next from 'i18next'
import classNames from 'classnames'
import {ColumnsType} from 'antd/es/table'
import {IPayByLinkStore} from '@/pages/PayByLink/IPayByLinkStore'
import {DateTimeLabel, Icon, TableStatus} from '@/components'
import {Status} from '@/components/dumb/Status'
import {PaymentLink, PaymentLinkOptionMode} from '@/api'
import {getAmountWithCurrency} from '@/utils'
import {TagType} from '@/components/dumb/Tag/props'
import {hasPermissions} from '@/stores/auth/services/utils'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'
import {
    getPayByLinkPaymentStatusName,
    getPayByLinkPaymentStatusTagType,
    getPayByLinkPaymentStatusIconType,
    getPayByLinkPaymentStatusExtraIconType
} from './statuses'
import {getPayByLinkListActionButtons} from './actions'

import styles from '../styles.scss'

export const getColumns = (payByLinkStore: IPayByLinkStore): ColumnsType<PaymentLink> => {
    return [
        {
            title: i18next.t('PayByLink.amount'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'right' as any,
            width: 150,
            render: (amount: number | string, record: PaymentLink) => {
                const isMultiUse = record?.linkOptions?.mode !== PaymentLinkOptionMode.ONE_OFF_FIXED
                const hasAmount = Number(amount) > 0

                if (!isMultiUse || hasAmount) {
                    return <b>{getAmountWithCurrency(amount, record.currency)}</b>
                }

                return (
                    <Status
                        className={styles.status}
                        type={TagType.Default}
                        status={i18next.t('PayByLink.open')}
                    />
                )
            }
        },

        {
            title: i18next.t('PayByLink.type'),
            dataIndex: 'type',
            key: 'type',
            align: 'right' as any,
            width: 150,
            render: (_: any, record: PaymentLink) => (
                <span style={{whiteSpace: 'nowrap'}}>
                    {record?.linkOptions &&
                    record?.linkOptions.mode != PaymentLinkOptionMode.ONE_OFF_FIXED
                        ? i18next.t('PayByLink.multiUse')
                        : i18next.t('PayByLink.oneTime')}
                </span>
            )
        },
        {
            title: i18next.t('PayByLink.status'),
            dataIndex: 'status',
            key: 'status',
            align: 'left' as any,
            width: 150,
            render: (item) => {
                return (
                    <TableStatus
                        statusProps={{
                            status: getPayByLinkPaymentStatusName(item),
                            type: getPayByLinkPaymentStatusTagType(item),
                            iconType: getPayByLinkPaymentStatusIconType(item),
                            className: classNames({
                                [styles.active]:
                                    getPayByLinkPaymentStatusTagType(item) === TagType.Active
                            })
                        }}
                        extra={<Icon type={getPayByLinkPaymentStatusExtraIconType(item)} />}
                    />
                )
            }
        },
        {
            title: i18next.t('PayByLink.description'),
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: i18next.t('PayByLink.dateCreated'),
            dataIndex: 'createdDate',
            key: 'createdDate',
            render: (item) => <DateTimeLabel date={item} />
        },
        {
            title: i18next.t('PayByLink.customer'),
            dataIndex: 'customerName',
            key: 'customerName',
            render: (item) => (item ? item : '-')
        },
        {
            title: i18next.t('PayByLink.expirationDate'),
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            render: (item) => <DateTimeLabel date={item} />
        },
        ...(hasPermissions([PermissionsMap.payment_links.full])
            ? [
                  {
                      title: i18next.t('PayByLink.action'),
                      dataIndex: '',
                      width: 230,
                      key: 'x',
                      render: (item, object) =>
                          getPayByLinkListActionButtons(object, payByLinkStore)
                  }
              ]
            : [])
    ]
}
